import { render, staticRenderFns } from "./SongsAuthorizationList.vue?vue&type=template&id=14289a78&scoped=true"
import script from "./SongsAuthorizationList.vue?vue&type=script&lang=js"
export * from "./SongsAuthorizationList.vue?vue&type=script&lang=js"
import style0 from "./SongsAuthorizationList.vue?vue&type=style&index=0&id=14289a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14289a78",
  null
  
)

export default component.exports